export default {
  setProfile(state, data) {
    state.profile = data;
  },

  setRoles(state, data) {
    state.roles = data;
  },
  setRole(state, data) {
    state.role = data;
  },
  setRoleCode(state, data) {
    state.roleCode = data;
  },

  setRolePermissions(state, data) {
    state.rolePermissions = data;
  },

  // User Access Managements
  setUserAccess(state, data) {
    state.userRoles = data.roles;
    state.defaultRole = data.defaultRoleId;
    state.defaultPermissions = data.permissions;
  },

  setDefaultPermissions(state, data) {
    state.defaultPermissions = data;
  },

  reloadNavbar(state, data) {
    state.reloadNavbar = data;
  },

  setUsers(state, data) {
    state.users = data;
  },
  setUser(state, data) {
    state.user = data;
  },

  setPersons(state, data) {
    state.persons = data;
  },
  setPersonByMobile(state, data) {
    state.personByMobile = data;
  },
  setPersonByNationalCode(state, data) {
    state.personByNationalCode = data;
  },
};
